import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RegistrationHeader from './components/RegistrationHeader';
import SocialRegistration from './components/SocialRegistration';
import RegistrationForm from './components/RegistrationForm';
import TrustSignals from './components/TrustSignals';
import Icon from '../../components/AppIcon';
import Footer from '../../components/ui/Footer';
import CustomerHeader from '../../components/ui/CustomerHeader';


const UserRegistration = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleFormSubmit = async (formData) => {
    setIsLoading(true);
    setSubmitError('');
    try {
      const API_BASE    = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_STOREFRONT_API_URL) || 'https://dashboard.offloadhost.com';
      const CUSTOMER_ID = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_CUSTOMER_ID) || '';
      const r = await fetch(`${API_BASE}/storefront/${CUSTOMER_ID}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          email: formData?.email,
          password: formData?.password,
          first_name: formData?.firstName,
          last_name:  formData?.lastName,
          newsletter_opt_in: !!formData?.newsletter,
        }),
      });
      const data = await r.json().catch(() => null);
      if (!r.ok) {
        const msg = data?.error
          || (r.status === 429 ? 'Too many attempts — please slow down.' : 'Could not create account. Please try again.');
        setSubmitError(msg);
        return;
      }
      setRegistrationSuccess(true);
      setTimeout(() => {
        navigate('/user-login', {
          state: {
            message: 'Account created! Check your email to verify, then sign in.',
            email: formData?.email,
          },
        });
      }, 1200);
    } catch (err) {
      console.error('Registration failed:', err);
      setSubmitError('Network error — please check your connection.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSocialRegister = async (provider) => {
    setIsLoading(true);
    
    try {
      // Simulate social registration
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      console.log(`${provider} registration successful`);
      
      // Show success and redirect
      setRegistrationSuccess(true);
      setTimeout(() => {
        navigate('/product-catalog');
      }, 1500);
      
    } catch (error) {
      console.error(`${provider} registration failed:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  if (registrationSuccess) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="w-full max-w-md text-center space-y-6">
          <div className="w-16 h-16 bg-success rounded-full flex items-center justify-center mx-auto">
            <Icon name="CheckCircle" size={32} color="white" />
          </div>
          <div className="space-y-2">
            <h2 className="text-2xl font-heading font-semibold text-foreground">
              Welcome to Bounderlaster!
            </h2>
            <p className="text-muted-foreground">
              Your account has been created successfully. Redirecting you now...
            </p>
          </div>
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <CustomerHeader
        cartItemCount={0}
        onCartClick={() => {}}
      />

      <div className="pt-16 flex-1">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5"></div>
        <div className="relative min-h-screen flex items-center justify-center p-4">
          <div className="w-full max-w-6xl">
            <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.3fr] gap-8 lg:gap-12">
              
              {/* Left Column - Header & Trust Signals */}
              <div className="space-y-8">
                <RegistrationHeader />
                
                {/* Trust Signals - Hidden on mobile, shown on desktop */}
                <div className="hidden lg:block">
                  <TrustSignals />
                </div>
              </div>

              {/* Right Column - Registration Form */}
              <div className="w-full">
                <div className="bg-card rounded-2xl shadow-elevation-2 border border-border p-6 lg:p-8">
                  
                  {/* Social Registration disabled — Google/Facebook OAuth not yet wired. */}

                  {/* Registration Form */}
                  <RegistrationForm 
                    onSubmit={handleFormSubmit}
                    isLoading={isLoading}
                  />

                  {/* Mobile Trust Signals */}
                  <div className="lg:hidden mt-8 pt-6 border-t border-border">
                    <TrustSignals />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default UserRegistration;